import { render, staticRenderFns } from "./AmetrasResponsiveTabBar.vue?vue&type=template&id=7b39a2d3&scoped=true&"
import script from "./AmetrasResponsiveTabBar.vue?vue&type=script&lang=ts&"
export * from "./AmetrasResponsiveTabBar.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasResponsiveTabBar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AmetrasResponsiveTabBar.vue?vue&type=style&index=1&id=7b39a2d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b39a2d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VList,VListItem,VMenu,VTab,VTabs})
